import type { ICharacterPerformance } from "@/pages/CreatorAnalytics/types";
import { cn } from "@/utils/cn";

import CharacterRow from "./CharacterRow";

const TH_BASE = "px-4 py-3 font-medium text-default-600";

const RANK_HEADER_LABEL = "#";
const TABLE_HEADERS: { key: string; label: string; alignment: "left" | "right"; visibility?: "sm" | "md" }[] = [
  { key: "character", label: "Character", alignment: "left" },
  { key: "requests", label: "Requests", alignment: "right" },
  { key: "users", label: "Users", alignment: "right", visibility: "sm" },
  { key: "convos", label: "Convos", alignment: "right", visibility: "md" },
  { key: "avgDepth", label: "Avg Depth", alignment: "right", visibility: "sm" },
  { key: "rating", label: "Rating", alignment: "right" },
  { key: "netLikes", label: "Net Likes", alignment: "right", visibility: "sm" },
];

const buildHeaderClassName = ({ alignment, visibility }: { alignment: "left" | "right"; visibility?: "sm" | "md" }) => {
  const alignmentClass = alignment === "left" ? "text-left" : "text-right";
  if (visibility === "sm") {
    return cn(TH_BASE, "hidden", alignmentClass, "sm:table-cell");
  }
  if (visibility === "md") {
    return cn(TH_BASE, "hidden", alignmentClass, "md:table-cell");
  }
  return cn(TH_BASE, alignmentClass);
};

interface ICharactersTableProps {
  rows: ICharacterPerformance[];
  rankOffset: number;
  onSelectCharacter?: (character: ICharacterPerformance) => void;
}

const CharactersTable = ({ rows, rankOffset, onSelectCharacter }: ICharactersTableProps) => (
  <div className="overflow-x-auto rounded-xl border border-default-200 dark:border-default-100">
    <table className="w-full text-sm">
      <thead>
        <tr className="border-b border-default-200 bg-default-50 dark:border-default-100 dark:bg-default-50/50">
          <th className={cn(TH_BASE, "text-left")}>{RANK_HEADER_LABEL}</th>
          {TABLE_HEADERS.map(({ key, label, alignment, visibility }) => (
            <th key={key} className={buildHeaderClassName({ alignment, visibility })}>
              {label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((char, idx) => (
          <CharacterRow
            key={char.characterId}
            character={char}
            rank={rankOffset + idx + 1}
            isClickable={!!onSelectCharacter}
            onSelect={onSelectCharacter}
          />
        ))}
      </tbody>
    </table>
  </div>
);

export default CharactersTable;
